import React from 'react';
import { Input } from 'antd';
import { useField } from 'formik';
import { MdAlternateEmail } from "react-icons/md";

const EmailInput = (props) => {
    const { className, placeholder, name, type = "text", size = "default size" } = props
    const [field, meta] = useField(name);

    return (
        <div className="form-group">
            <Input
                className={className}
                size={size}
                {...field}
                type={type}
                placeholder={placeholder}
                suffix={<MdAlternateEmail />}
                status={meta.touched && meta.error && "error"}
            />
            {/* {meta.touched && meta.error ? (
                <span className="error-input-message">{meta.error}</span>
            ) : null} */}
        </div>
    );
}

export default EmailInput;
